import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component'
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';


@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit, AfterViewInit {
  @Input() tabName: string = '';
  @Output() next = new EventEmitter<void>();
  // @Output() prev = new EventEmitter<void>();
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  @Output() jump = new EventEmitter<void>();
  // @Output() jump: EventEmitter<string> = new EventEmitter<string>();

  dialogRef: MatDialogRef<any>;
  PCountryCodeList: any;
  filteredListPCountryCode: any;
  CCountryCodeList: any;
  CfilteredListCountryCode: any;
  districtCodeList: any;
  isreadonly = false;
  disabled = false
  nationalityList: any;
  filteredNationalityList: any;
  domicileList: any;
  filteredDomicileList: any;
  regionList: any;
  filteredRegionList: any;
  tabs: string;
  displayName: any;
  Course: any;
  College: any;
  SnNo: any;
  StuId: any;
  StuResId: any;
  isIndian : boolean = true;
  StuNationality : any;

  constructor(private fb: FormBuilder, private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    private router: Router,
    public umsService: UmsService,
    private spinner: NgxSpinnerService) { }
  session = sessionStorage.getItem('session');
  contactDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  stateCity: any;
  stateCityArr = [];
  districtData: any;
  filteredList: { state: string; districts: string; }[];
  filteredListDistrict: { district: string; }[];
  contactDetailsFormArray;
  selectedIndex: number = 1;
  maxNumberOfTabs = 2;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  tehasilPList
  filteredtehasilPList
  tehasilCList
  filteredtehasilCList
  StateCodeListP
  filteredListStateP
  StateCodeListC
  filteredListStateC
  districtCodeListP
  filteredListDistrictP
  districtCodeListC
  filteredListDistrictC
  isSaveUpdateDisable = true;
  ContactShow = false;
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)

  ngOnInit(): void {
    this.isSaveUpdateDisable = true;
    this.ContactShow = false;
    this.session = sessionStorage.getItem('session');
    // this.prepopulation2Flag = false;
    // this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false;
    this.contactDetailsForm = this.fb.group({
      StuId: new FormControl(''),
      StuAddrId: new FormControl(),
    });
    this.spinner.show();
    this.getSecretData();
    this.fetchPersonal();
    this.fetchCountryP();
    this.fetchCountryC()
    this.fetchNationality();
    this.fetchDomicile();
    this.fetchRegion();
    this.getApplyData();

  }

  ngAfterViewInit(): void {
    // this.DisableSaveUpdateButton();
    //this.prepopulation();
  }

  fetchPersonal() {
    this.calledApi++;
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe(async (res) => {
      if (res.status) {
        sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
        this.StuId = res.data[0].StuId;
        this.prepopulation();
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      };
    })
  }

  getSecretData() {
    this.calledApi++;
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.SnNo = res.projectPharam['SnNo'];
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      };
    });
  }

  getFeeStatus(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      if (res.status) {
        console.log('fees status response i get is', res.data);
        this.getScrutiny(StuId)
      }
      else {
        this.disabled = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.disabled = false;
    })
  }

  getScrutiny(StuId) {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.finishedApi++; // Increment the finished API count
      this.tabs = res.data[0].Tabs;
      if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        if (res.data[0].Tabs.includes('Contact Details')) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
      else {
        this.disabled = true;
      }
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide(); //
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  prepopulation() {
    let payload = {};
    payload['StuId'] = this.StuId;
    this.umsService.fetchContactDetails(payload).subscribe(async (res) => {
      if (res.status) {
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
          this.isIndian = false;
        }
        this.spinner.hide()
        if (res.data.length > 0) {

          await this.fetchStateC2(res.data[0].StuCountryC);
          await this.fetchStateP2(res.data[0].StuCountryP);
          await this.fetchDistrictC2(res.data[0].StuStateC);
          await this.fetchDistrictP2(res.data[0].StuStateP);

          // this.umsService.disable2 = false;
          if (res.data[0].StuSameAddr == 1) {
            this.isreadonly = true;
          } else {
            this.isreadonly = false;
          }
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.updateButton = true;
          this.submitButton = false;
          await this.prepopulatedatapage(res);
          await this.getFeeStatus(res.data[0].StuId)
          //  await this.getScrutiny();
        } else {
          await this.loadsettingspage();
          // await this.getScrutiny();
        }
      } else {

        await this.loadsettingspage();
        //  await this.getScrutiny();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })

  }


  prepopulatedatapage(e) {
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.contactDetailsForm.controls['StuAddrId'].setValue(e.data[0]['StuAddrId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide()
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormControlName == 'StuEmailId' && element.FormRequired == true) {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.email, Validators.pattern('(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]));
          }
          else if (element.FormControlName == 'StuEmailId' && element.FormRequired == false) {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.email, Validators.pattern('(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]));
          }
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
            else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
            }
          }
        } else {
          this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.contactDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ContactShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
    //this.DisableSaveUpdateButton();
  }

  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormControlName == 'StuEmailId' && element.FormRequired == true) {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.email, Validators.pattern('(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]));
          }
          else if (element.FormControlName == 'StuEmailId' && element.FormRequired == false) {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.email, Validators.pattern('(?![0-9]+@)[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]));
          }
          if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
              } else {
                this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
              }
          } else {
              if (element.FormPattern == '') {
                this.contactDetailsForm.addControl(element.FormControlName, new FormControl(''));
              } else {
                this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
              }
          }
        }
      });
      this.contactDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ContactShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
    //this.DisableSaveUpdateButton();
  }

  fetchCountryP() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    this.StateCodeListP = []
    this.filteredListStateP = []
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.umsService.getCountry(payload).subscribe(res => {
      if (res.status) {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.PCountryCodeList = res.data;
        this.filteredListPCountryCode = this.PCountryCodeList.slice();
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  fetchCountryC() {
    this.calledApi++; // Increment the called API count;
    const payload = {};
    this.StateCodeListC = []
    this.filteredListStateC = []
    this.districtCodeListC = []
    this.filteredListDistrictC = []
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.filteredListStateC = []
    this.umsService.getCountry(payload).subscribe(res => {
      if (res.status) {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
        this.CCountryCodeList = res.data;
        this.CfilteredListCountryCode = this.CCountryCodeList.slice();
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  fetchStateP(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
        this.contactDetailsForm.controls["StuStateP"].setValue('');

      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchStateP2(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchStateP3(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchStateC(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
        this.contactDetailsForm.controls["StuStateC"].setValue('');
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchStateC2(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchDistrictP(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
        this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchDistrictP2(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchDistrictP3(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getTehasilDataP3(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilPList = res.data;
        this.filteredtehasilPList = this.tehasilPList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  fetchDistrictC(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
        this.contactDetailsForm.controls["StuDistrictC"].setValue('');
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  fetchDistrictC2(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getTehasilDataC(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilCList = res.data;
        this.filteredtehasilCList = this.tehasilCList.slice();
        this.contactDetailsForm.controls["StuTehsilC"].setValue('');
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getTehasilDataC2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilCList = res.data;
        this.filteredtehasilCList = this.tehasilCList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getTehasilDataP(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilPList = res.data;
        this.filteredtehasilPList = this.tehasilPList.slice();
        this.contactDetailsForm.controls["StuTehsilP"].setValue('');
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getTehasilDataP2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilPList = res.data;
        this.filteredtehasilPList = this.tehasilPList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  copyAddress(e) {
    if (e.checked == true) {
      this.isreadonly = true;
      let payload = this.contactDetailsForm.value.StuAddrC;
      let payload2 = this.contactDetailsForm.value.StuCountryC;
      this.fetchStateP3(payload2);
      let payload3 = this.contactDetailsForm.value.StuStateC;
      this.fetchDistrictP3(payload3)
      let payload4 = this.contactDetailsForm.value.StuDistrictC;
      let payload6 = this.contactDetailsForm.value.StuCityC;
      let payload7 = this.contactDetailsForm.value.StuPinC;
      let payload8 = this.contactDetailsForm.value.StuAddr2C;
      let payload9 = this.contactDetailsForm.value.StuAddr3C;
      let payload10 = this.contactDetailsForm.value.StuAddr4C
      this.contactDetailsForm.controls["StuAddrP"].setValue(payload);
      this.contactDetailsForm.controls["StuCountryP"].setValue(payload2);
      this.fetchStateP3(payload2)
      this.contactDetailsForm.controls["StuStateP"].setValue(payload3);
      this.fetchDistrictP3(payload3);
      this.contactDetailsForm.controls["StuDistrictP"].setValue(payload4);
      this.contactDetailsForm.controls["StuCityP"].setValue(payload6);
      this.contactDetailsForm.controls["StuPinP"].setValue(payload7);
      this.contactDetailsForm.controls["StuAddr2P"].setValue(payload8);
      this.contactDetailsForm.controls["StuAddr3P"].setValue(payload9);
      this.contactDetailsForm.controls["StuAddr4P"].setValue(payload10);
    }
    else {
      this.isreadonly = false;
      this.contactDetailsForm.controls["StuAddrP"].setValue('');
      this.contactDetailsForm.controls["StuCountryP"].setValue('');
      this.contactDetailsForm.controls["StuStateP"].setValue('');
      this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      this.contactDetailsForm.controls["StuCityP"].setValue('');
      this.contactDetailsForm.controls["StuPinP"].setValue('');
      this.contactDetailsForm.controls["StuAddr2P"].setValue('');
      this.contactDetailsForm.controls["StuAddr3P"].setValue('');
      this.contactDetailsForm.controls["StuAddr4P"].setValue('');

    }
  }

  SubmitFormarkAsTouched() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.contactDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.contactDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  submitContactDetails() {
    if (this.StuNationality === 'OS') {
      this.contactDetailsForm.clearValidators();

      Object.entries(this.contactDetailsForm.controls).forEach(([name, control]) => {
        if (name === 'StuNationality' || name === 'StuCountryC') {
          control.setValidators(Validators.required);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity({ onlySelf: true });
      });
      this.contactDetailsForm.updateValueAndValidity();
    }

    if (this.contactDetailsForm.invalid) {
      this.SubmitFormarkAsTouched();
    } else {
      // this.spinner.show();
      let payload = this.contactDetailsForm.value;
      if (this.contactDetailsForm.value.StuSameAddr == 1 || this.contactDetailsForm.value.StuSameAddr == true) {
        payload['StuAddrP'] = this.contactDetailsForm.value.StuAddrC;
        payload['StuCountryP'] = this.contactDetailsForm.value.StuCountryC;
        payload['StuStateP'] = this.contactDetailsForm.value.StuStateC;
        payload['StuDistrictP'] = this.contactDetailsForm.value.StuDistrictC;
        payload['StuCityP'] = this.contactDetailsForm.value.StuCityC;
        payload['StuPinP'] = this.contactDetailsForm.value.StuPinC;
        payload['StuAddr2P'] = this.contactDetailsForm.value.StuAddr2C;
        payload['StuAddr3P'] = this.contactDetailsForm.value.StuAddr3C;
        payload['StuAddr4P'] = this.contactDetailsForm.value.StuAddr4C;
        payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
      }
      payload['LoginId'] = sessionStorage.getItem('StudentRGID');
      payload['StuId'] = this.StuId;
      this.umsService.addContactDetails(payload).subscribe(res => {
        if (res.status) {
          if (this.contactDetailsForm.value.StuNationality === 'OS' || this.contactDetailsForm.value.StuNationality == 'OS') {
            this.umsService.studentProgressList['StudentReservation'] = 1;
            this.autoSubmitReservationDetails(); // This will set tab to 3
            return;
          }
          else {
            let data = {}
            data['message'] = res.message
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
            this.next.emit();
          }
        }
      },
      )
    }
  }

  autoSubmitReservationDetails() {
    const payload = {
      LoginId: parseInt(sessionStorage.getItem('StudentRGID')),
      StuConstiCate: '',
      StuConstiSubCate: 'GM',
      StuId: this.StuId,
      StuNonCrmValDt: null,
      StuPhyHand: 0,
      StuResId: '',
      StuSocialRes: 'NA',
      StuSpecialAbledType: 'NA'
    };

    this.umsService.addReservationDetails(payload).subscribe(res => {
      // if (res.status) {
      this.umsService.studentProgressList['StudentReservation'] = 1;
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // this.jump.emit();
            setTimeout(() => {
        this.jump.emit();
      }, 200);
      // }
    });
  }

  // getTabName(e) {
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }
  UpdateContactDetails() {

console.log('this.contactDetailsForm',this.contactDetailsForm)
if (this.contactDetailsForm.value.StuNationality === 'OS') {
    Object.entries(this.contactDetailsForm.controls).forEach(([name, control]) => {
      if (name === 'StuNationality' || name === 'StuCountryC') {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity({ onlySelf: true });
    });
    this.contactDetailsForm.updateValueAndValidity();
  }
    if (this.contactDetailsForm.invalid) {
      this.SubmitFormarkAsTouched()
      return;
    }
        this.update();
   
  }

  update() {
    // this.spinner.show();
    let payload = this.contactDetailsForm.value;
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    if (this.contactDetailsForm.value.StuSameAddr == 1 || this.contactDetailsForm.value.StuSameAddr == true) {
      payload['StuAddrP'] = this.contactDetailsForm.value.StuAddrC;
      payload['StuCountryP'] = this.contactDetailsForm.value.StuCountryC;
      payload['StuStateP'] = this.contactDetailsForm.value.StuStateC;
      payload['StuDistrictP'] = this.contactDetailsForm.value.StuDistrictC;
      payload['StuCityP'] = this.contactDetailsForm.value.StuCityC;
      payload['StuPinP'] = this.contactDetailsForm.value.StuPinC;

      payload['StuAddr2P'] = this.contactDetailsForm.value.StuAddr2C;
      payload['StuAddr3P'] = this.contactDetailsForm.value.StuAddr3C;
      payload['StuAddr4P'] = this.contactDetailsForm.value.StuAddr4C;
    }
    payload['LoginId'] = sessionStorage.getItem('StudentRGID');
    payload['StuId'] = this.StuId;
    this.umsService.updateContactDetails(payload).subscribe(res => {
      if (res.status) {
      this.umsService.setTabSaved('contactTab');
      if (this.tabs &&
        this.umsService.isRequiredTabsSaved(this.tabs)) {
        const data = {};
        data['message'] =
          'Are You Sure You Have Updated ' +
          this.tabs +
          ' Tabs. Do You Want To Proceed?';

        data['title'] = 'Alert';
        data['icon'] = 'fa fa-question';

        this.dialogRef =
          this.modalPopupService.openPopup<ConformationModelComponent>(
            ConformationModelComponent,
            data
          );

        this.dialogRef.afterClosed().subscribe(result => {
          if (result === 'yes') {
            this.UpdScrtDetails();
            if (this.tabs?.includes('Wrong Payment')) {
            this.router.navigate(['/Fees']);
      }
          }
        });
      }

      // this.spinner.hide();
      if (this.contactDetailsForm.value.StuNationality === 'OS' || this.contactDetailsForm.value.StuNationality == 'OS') {
        this.umsService.studentProgressList['StudentReservation'] = 1;
        // this.autoUpdateReservationDetails(); // This will set tab to 3
        this.checkforReservation();
        return;
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.next.emit();
      }
    } }
    );
  }


  autoUpdateReservationDetails() {
    // this.spinner.show();
    const payload = {
      StuId: this.StuId, // or your key
      StuResId: this.StuResId ? this.StuResId : '',
      StuCaste: null,
      StuCasteCert: null,
      StuCasteValCert: null,
      StuNonCrmCert: null,
      StuNonCrmValDt: null,
      StuMinority: null,
      StuInHouse: null,
      StuOrphanType: null,
      StuOrphan: null,
      StuConstiCate: null,
      StuConstiSubCate: 'GM',
      StuPhyHand: 0,
      StuSocialRes: 'NA',
      StuMinorityType: null,
      StuMinorityType2: null,
      StuSpecialAbledType: 'NA',
      BPLCategory: false,
      LoginId: parseInt(sessionStorage.getItem('StudentRGID'))
    };
    this.umsService.updateReservationDetails(payload).subscribe(res => {
      // if (res.status) {
      // this.spinner.hide();
      this.umsService.studentProgressList['StudentReservation'] = 1;
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // this.jump.emit();
      setTimeout(() => {
        this.jump.emit();
      }, 200);
      // }
    });
  }
  UpdScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.first.emit();
        location.reload();
      }
      else {

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getApplyData() {
    this.calledApi++; // Increment the called API count
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.Course = res.data[0]['Course'];
        this.College = res.data[0]['College'];
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide(); //
        }
      }
      else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide(); //
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide(); //
      }
    });
  }

  back() {
    this.prev.emit(false);
  }

  fetchNationality() {
    this.calledApi++; // Increment the called API count;
    const payload = {};
    payload['CdType'] = 'NL';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchDomicile() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'Dm';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.domicileList = res.data;
        this.filteredDomicileList = this.domicileList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchRegion() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'Regio';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.regionList = res.data;
        this.filteredRegionList = this.regionList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }
  checkforReservation() {
    let payload = {}; 
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchReservationDetails(payload).subscribe( (res) => {
     if(res.status) {
        if(res.data[0].StuId){
        this.autoUpdateReservationDetails();
        }
      }
      else{
        this.autoSubmitReservationDetails();
      }
    },(ERROR: HttpErrorResponse) => {
    })

  }

  nationalitySelection(data:any) {
    this.StuNationality = data.CdCode;
    if(data.CdCode == 'OS') {
      this.isIndian = false;
    }
    else { this.isIndian = true; }
  }
}

